<template>
  <v-container class="password-LoginForm-container">
    <v-layout row>
      <v-flex>
        <v-text-field
          class="login-password-form"
          v-model="password"
          name="password"
          :type="showPassword ? 'text' : 'password'"
          label="パスワード"
          box
        >
          <template v-slot:append>
            <v-icon
              class="fa-sm"
              style="cursor: pointer;"
              @click="togglePassword"
            >
              {{ showPassword ? "fa-eye" : "fa-eye-slash" }}
            </v-icon>
          </template>
        </v-text-field>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      password: "",
      showPassword: false,
    };
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>

<style lang="scss">
.password-LoginForm {
  &-container {
    padding: 0px !important;
  }
}
</style>
